import { Injectable, inject } from '@angular/core';
import { EditLenderNetworksViewModel } from '@shared/models';
import { ClubHubDataService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LenderNetworksService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public getNetworks(lenderId: number) {
    return this.clubHubDataService.get<EditLenderNetworksViewModel>(`LenderNetworks/${lenderId}`);
  }

  public updateRestrictions(lenderId: number, frnNumbers: number[]): Observable<void> {
    return this.clubHubDataService.put<never>(`LenderNetworks/${lenderId}`, frnNumbers);
  }
}
